import { LOADING_DOCUMENT_FOR_PRINT } from './types';

export default function dispatchPrintEvent(isPrinting) {
  return { type: LOADING_DOCUMENT_FOR_PRINT, payload: isPrinting };
}
